import { Component, Input } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { PostAnswersComponent } from './post-answers/post-answers.component';
import { BrowserService } from 'src/_lib/service/browser.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf, NgClass]
})
export class FaqsComponent {
  product_key: number = null;
  isAccordionOpen = false;
  selectedQuestionId: string | null = null;
  answers: any[] = [];
  openFaq: string | null = null;

  @Input() faqsData: any;

  constructor(
    private dialog: MatDialog,
    private browser: BrowserService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const id: string = this.route.snapshot.params['id'] || '';
    if (id.startsWith('p') && id.length > 1) {
      this.product_key = +id.slice(1) || null;
    } else {
      this.product_key = +this.browser.localStorage?.getItem('selectedproductkey') || null;
    }
  }

  onQuestionClick(questionId: string) {
    if (this.selectedQuestionId === questionId) {
      this.selectedQuestionId = null;
      this.answers = [];
    } else {
      this.selectedQuestionId = questionId;
    }
  }

  toggleFaq(key: string) {
    this.openFaq = this.openFaq === key ? null : key;
  }

  naviagteToPostAnswer(): void {
    this.dialog.open(PostAnswersComponent);
  }
}